<div class="patientDeactivationUpdateDialog">
  <mat-dialog-content>
    <h3>{{ "model.patient.disablePatientType.updateTitle" | translate }}</h3>

    <div class="updateField">
      <mat-form-field>
        <mat-label>{{ "model.patient.disablePatientType.subStatus" | translate }}</mat-label>
        <mat-select [(ngModel)]="selectedSubStatus" (selectionChange)="onSubStatusChange()">
          <mat-option *ngFor="let reason of subStatusOptions" [value]="reason">
            {{ "model.patient.disablePatientReason." + reason | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="updateField" *ngIf="selectedSubStatus === reasons.OTHER">
      <mat-form-field>
        <mat-label>{{ "model.patient.disablePatientReason.otherPlaceholder" | translate }}</mat-label>
        <input matInput type="text" [(ngModel)]="otherReason" maxlength="30" />
      </mat-form-field>
      <mat-error *ngIf="otherReasonMissing">
        {{ "model.patient.disablePatientReason.otherRequired" | translate }}
      </mat-error>
    </div>

    <div class="updateField">
      <mat-form-field class="dateInput">
        <mat-label>{{ "model.patient.disablePatientType.newEndDate" | translate }}</mat-label>
        <input matInput [matDatepicker]="endDatePicker" [min]="minEndDate" [(ngModel)]="endDate" />
        <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #endDatePicker></mat-datepicker>
        <mat-hint *ngIf="startDate">
          {{ "model.patient.disablePatientType.newEndDateHint" | translate : { date: data.deactivation.date | safeDate } }}
        </mat-hint>
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button cdkFocusInitial mat-dialog-close>
      {{ "btn.cancel" | translate }}
    </button>
    <button mat-button color="primary" [disabled]="!canSubmit" (click)="onValidate()">
      {{ "btn.validate" | translate }}
    </button>
  </mat-dialog-actions>
</div>
